module.exports = __webpack_public_path__ + "static/media/Team 38 - Cre8.591e58df.png";